import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from '@domgen/dgx-components';
import { CONFIG } from '@domgen/dgx-fe-config';
import { GAService } from '@domgen/dgx-fe-ga';

@Component({
  selector: 'claims-unavailable-documents',
  styleUrls: ['./unavailable-docs.component.scss'],
  templateUrl: './unavailable-docs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnavailableDocumentsComponent {
  constructor(
    private dialogRef: MatDialogRef<UnavailableDocumentsComponent>,
    private gaService: GAService,
    @Inject(CONFIG) private config: AppConfig
  ) {}
  handleClose(): void {
    this.gaService.tag({
      clientName: 'DG My Account',
      event: 'genericGAEvent',
      eventCategory: 'plan_details',
      eventAction: 'plan_info',
      eventLabel: 'plan_doc_error_modal_close',
    });
    this.dialogRef.close();
  }

  handleHelpAndFaqClick(): void {
    this.gaService.tag({
      clientName: 'DG My Account',
      event: 'genericGAEvent',
      eventCategory: 'plan_details',
      eventAction: 'plan_info',
      eventLabel: 'plan_doc_FAQ',
    });
    window.open(this.config.faqsMyAccountUrl, '_blank', 'noopener');
  }
}
